export default __webpack_public_path__ + "static/media/talent-cloud.b0638587.svg";